var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3578 13.791C16.3048 12.66 15.0358 11.819 13.6858 11.297C15.1438 10.224 16.1158 8.397 16.1158 6.338C16.1158 3.177 13.7668 0.508996 10.8238 0.334996C7.58384 0.131996 4.91084 2.916 4.91084 6.338C4.91084 8.397 5.88284 10.195 7.34084 11.297C5.96384 11.819 4.72184 12.631 3.66884 13.791C2.02184 15.56 1.04984 17.822 0.860835 20.287C0.833835 20.751 1.18484 21.157 1.61684 21.157C2.02184 21.157 2.34584 20.838 2.37284 20.403C2.72384 15.908 6.23384 12.37 10.4998 12.37C14.7658 12.37 18.2758 15.908 18.6538 20.403C18.6808 20.838 19.0048 21.157 19.4098 21.157C19.8418 21.157 20.1928 20.751 20.1658 20.287C19.9768 17.822 18.9778 15.56 17.3578 13.791ZM11.0398 10.717C8.36684 11.094 6.12584 8.658 6.44984 5.787C6.69284 3.844 8.15084 2.249 9.95984 2.017C12.6328 1.64 14.8738 4.076 14.5498 6.947C14.3338 8.89 12.8488 10.456 11.0398 10.717Z",
    fill: "#858AF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonBlue);
export default __webpack_public_path__ + "static/media/person_blue.b6e6a8340fe11296386dd568b0e67593.svg";
export { ForwardRef as ReactComponent };